import AncillaryRow, {
  type AncillaryRowProps,
} from '@/components/purchase/checkout/ancillaries/AncillaryRow';
import { type BookedAncillaryDTO } from '@/types/dto/agent';
import { cn } from '@/utils/cn';
import { Accordion, Icons, Typography } from '@packages/webshop-design-system';
import type { FC, ReactNode } from 'react';

export interface LegSectionAncillaryAccordionProps {
  title: ReactNode;
  classNames?: string;
  ancillaryRows: Array<{
    ancillary: BookedAncillaryDTO;
    isRemoveDisabled: boolean;
  }>;
  handleRemoveAncillary: AncillaryRowProps['handleRemoveAncillary'];
}

const LegSectionAncillaryAccordion: FC<LegSectionAncillaryAccordionProps> = ({
  title,
  classNames,
  ancillaryRows,
  handleRemoveAncillary,
}) => {
  return (
    <Accordion
      defaultExpanded
      className={cn('border-neutral-pale pb-4', classNames)}
      classNames={{
        trigger:
          'my-4 justify-start gap-2 py-0 text-primary hover:no-underline',
        content: 'flex flex-col gap-3 pl-7',
      }}
      trigger={
        <>
          <Icons.addon className="h-5 w-5" />
          <Typography variant="body1-bold">{title}</Typography>
        </>
      }
    >
      {ancillaryRows.map(({ ancillary, isRemoveDisabled }, key) => (
        <AncillaryRow
          ancillary={ancillary}
          icon={<Icons.addon height={16} width={16} className="text-primary" />}
          isRemoveDisabled={isRemoveDisabled}
          handleRemoveAncillary={handleRemoveAncillary}
          key={key}
        />
      ))}
    </Accordion>
  );
};

export default LegSectionAncillaryAccordion;
